/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { EFAX_ANALOG_PORT_MESSAGE, FORWARD_PROPERTY, NUMBER_TYPES, VMAIL_PROPERTY, TOLL_FREE_PROPERTY } from '../../lib/constants';
import ConfirmationModal from '../ConfirmationModal';
import { isEscene } from '../../lib/utils.js';

function findSelectedType(type, defaultTypes) {
  if (!type) {
    return defaultTypes[0];
  }
  return defaultTypes.find(numberType => numberType?.value === type);
}

class NumberTypeSelect extends Component {
  constructor(props) {
    super(props);
    const baseTypes =
      props.comingFrom !== 'number'
        ? NUMBER_TYPES
        : [...NUMBER_TYPES, /* FORWARD_PROPERTY,*/ VMAIL_PROPERTY, TOLL_FREE_PROPERTY];

    // External ATA can only be assigned as Fax types.
    this.NUMBER_TYPES = props.externalAta
      ? baseTypes.filter(t => t?.value === 'fax' || t?.value === 'faxStandard' || t?.value === 't38hunt')
      : baseTypes;

    if (props.includeCallIdMask && !props.externalAta) {
      this.NUMBER_TYPES.push({ value: 'callIdMask', label: 'Call ID Mask', active: true });
    }

    this.allowEfax = !!props.allowEfax && !props.externalAta;
    if (!this.allowEfax) {
      this.NUMBER_TYPES = this.NUMBER_TYPES.filter(numberType => numberType.value !== 'efax');
    }

    const externalAtaDefaultType =
      props.selectedType === 'fax' || props.selectedType === 'faxStandard' ||  props.selectedType === 't38hunt' ? props.selectedType : 'fax';
    this.state = {
      dropdownOpen: false,
      selectedType:
        findSelectedType(props.externalAta ? externalAtaDefaultType : props.selectedType, this.NUMBER_TYPES) ||
        {
          label:
            props.selectedType === 'sip'
              ? 'CAS'
              : props.selectedType === 'pri'
                ? 'PRI'
                : '',
          value: props.externalAta ? externalAtaDefaultType : props.selectedType,
          active: true,
        },
      // selectedType: findSelectedType(props.externalAta ? externalAtaDefaultType : props.selectedType, this.NUMBER_TYPES),
      dropdownList: this.NUMBER_TYPES,
      confirmModalStatus: false,
         confirmModalStatusT38: false,
      numberTypeTemp: ''
    };
  }

  componentDidMount() {
    const { selectedType, dropdownList } = this.state;
    const { box } = this.props;
    this.onTypeSelect(selectedType);
    if (!box?.enhancedFax) {
      const updatedList = dropdownList.map(numberType => {
        if (numberType?.value === 'faxStandard' || numberType?.value === 't38hunt') {
          return { ...numberType, active: false };
        }
        return numberType;
      });
      this.setState({ dropdownList: updatedList });
    }
  }

  componentDidUpdate(prevProps) {
    const { dropdownList } = this.state;
    // In External ATA flows, other UI actions (like selecting a number) can overwrite the
    // parent's `type` back to `unassigned`. Force it back to fax so validation passes.
    if (
      this.props.externalAta &&
      (prevProps.selectedType !== this.props.selectedType || prevProps.externalAta !== this.props.externalAta) &&
      this.props.selectedType !== 'fax' &&
      this.props.selectedType !== 'faxStandard' &&
      this.props.selectedType !== 't38hunt'

    ) {
      const faxType = findSelectedType('fax', dropdownList) || this.NUMBER_TYPES?.[0];
      if (faxType) {
        this.onTypeSelect(faxType);
      }
      return;
    }
    if (this.props.selectedType !== prevProps.selectedType) {
      // this.setState({
      //   selectedType: findSelectedType(
      //     this.props.externalAta
      //       ? (this.props.selectedType === 'fax' || this.props.selectedType === 'faxStandard'
      //         ? this.props.selectedType
      //         : 'fax')
      //       : this.props.selectedType,
      //     dropdownList
      //   ),
      // });
      const resolvedType = this.props.externalAta
      ? (this.props.selectedType === 'fax' || this.props.selectedType === 'faxStandard'
        ? this.props.selectedType
        : 'fax')
      : this.props.selectedType;
    this.setState({
      selectedType:
        findSelectedType(resolvedType, dropdownList) ||
        {
          label:
            resolvedType === 'sip'
              ? 'CAS'
              : resolvedType === 'pri'
              ? 'PRI'
              : '',
          value: resolvedType,
          active: true,
        },
    });    }
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onTypeSelect = numberType => {
    const { onTypeSelect, boxDetails, externalAta } = this.props;
    if (numberType?.value === 'efax') {
      if (!this.allowEfax) {
        toast.error(EFAX_ANALOG_PORT_MESSAGE);
        return;
      }
      this.setState({ selectedType: numberType });
      onTypeSelect(numberType);
      return;
    }
    if (numberType?.value === 'fax' && numberType?.value !== this.props.selectedType && !externalAta) {
      this.setState({ confirmModalStatus: true });
    } else if (numberType?.active) {
      if (numberType?.value === 'faxStandard' || numberType?.value === 't38hunt'   && isEscene(boxDetails?.Obis[0]?.macAddress) && numberType?.value !== this.props.selectedType) {
        this.setState({ confirmModalStatusT38: true, numberTypeTemp: numberType })
        return
      }
      this.setState({
        selectedType: numberType,
      });
      onTypeSelect(numberType);
    } else {
      toast.error(
        'Enhanced Fax is required for T.38. Please enable Enhanced Fax from the Options Menu.',
      );
    }
  };

  simplifiedString = (label) => (label?.split('(')[0]?.trim() || "")?.replace(/\s+/g, "_")?.replace(/_-_/g, "_")?.toLowerCase();

  renderTypes = () => {
    const { dropdownList } = this.state;
    const updatedDropdownList = [
      ...dropdownList.filter(item => item?.value !== 'sip' && item?.value !== 'pri'),
      { label: 'CAS', value: 'sip', active: true },
      { label: 'PRI', value: 'pri', active: true },
    ];
    const selectedTypeValue = this.props.externalAta
      ? (this.props.selectedType === 'fax' || this.props.selectedType === 'faxStandard' || this.props.selectedType === 't38hunt'
        ? this.props.selectedType
        : 'fax')
      : this.props.selectedType;
    const currentValue = this.props.onlyEfax && selectedTypeValue === 'fax' ? 'efax' : selectedTypeValue;
    return updatedDropdownList
      .filter(numberType => numberType?.value !== currentValue)
      .map(numberType => {
        return (
          <DropdownItem
            style={{ backgroundColor: !numberType?.active ? '#ccc' : null }}
            key={numberType?.value}
            id={this.simplifiedString(numberType?.label)}
            onClick={() => this.onTypeSelect(numberType)}
          >
            {numberType.label}
          </DropdownItem>
        );
      });
  };

  render() {
    const { selectedType, dropdownOpen, dropdownList, confirmModalStatus,confirmModalStatusT38,numberTypeTemp  } = this.state;
    const { disabledAdmin, className, toggleClassName, boxDetails, externalAta } = this.props;
    const selectedTypeValue = externalAta
      ? (this.props.selectedType === 'fax' || this.props.selectedType === 'faxStandard' || this.props.selectedType === 't38hunt'
        ? this.props.selectedType
        : 'fax')
      : this.props.selectedType;
    const showingEfax = this.props.onlyEfax && selectedTypeValue === 'fax';
    const displayType = showingEfax
      ? 'EFAX'
      : selectedTypeValue === 'sip'
        ? 'CAS'
        : selectedTypeValue === 'pri'
          ? 'PRI'
          : findSelectedType(selectedTypeValue, dropdownList)?.label;
    return (
      <>
      <Dropdown className={className} name="type" isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle
          className={toggleClassName}
          id={this.simplifiedString(selectedType?.label)}
          disabled={disabledAdmin || false}
          caret
        >
          {selectedTypeValue
            ? displayType
            : selectedType?.label}
        </DropdownToggle>
        <DropdownMenu>{this.renderTypes()}</DropdownMenu>
      </Dropdown>
        <ConfirmationModal
          isOpen={confirmModalStatus}
          onCancel={() => { this.setState({ confirmModalStatus: false, selectedType }); }}
          bodyText={isEscene(boxDetails?.Obis[0]?.macAddress) ? "If there is already a Fax on the current EPI, please use a different ATA when adding a new fax line for best possible results.": "Fax Relay Protocol (T.37) should only be used in high volume Faxing scenarios. Are you sure you want to proceed?"}
          onConfirm={() => {
            this.setState({
              confirmModalStatus: false,
              selectedType: findSelectedType('fax', dropdownList)
            }, () => this.props.onTypeSelect(this.state.selectedType));
          }}
          headerText={"Attention"}
        />
        <ConfirmationModal
          isOpen={confirmModalStatusT38}
          onCancel={() => this.setState({ confirmModalStatusT38: false, selectedType })}
          bodyText={'If there is already a Fax on the current EPI, please use a different ATA when adding a new T38 fax line'}
          onConfirm={() => {
            this.setState(
              {
                confirmModalStatusT38: false,
                selectedType: numberTypeTemp,
              },
              () => {
                if (this.props.onTypeSelect) {
                  this.props.onTypeSelect(numberTypeTemp);
                }
              }
            );
          }}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  box: state.AppState.boxDetails.box,
});

export default connect(
  mapStateToProps,
  null,
)(NumberTypeSelect);
